import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const DiffFieldLayout = ({
  label,
  oldElement,
  newElement,
}: {
  label: string;
  oldElement: React.ReactNode;
  newElement: React.ReactNode;
}) => (
  <Grid
    size={{
      xs: 12,
      md: 6,
      xl: 3,
    }}
  >
    <Box display="flex" flexDirection="column">
      <Typography variant="mediumTitle">{label}</Typography>
      <Box display="flex" flexDirection="row" alignItems="center">
        {oldElement}
        <ArrowForwardIcon sx={{ marginX: 2 }} fontSize="small" />
        {newElement}
      </Box>
    </Box>
  </Grid>
);

export default DiffFieldLayout;
